'use client';

import { ListItem } from '@coolblue-development/freddy';
import { ReactNode } from 'react';

type CellProps = { children?: ReactNode };

const Cell = ({ children }: CellProps) => (
  <ListItem
    py={200}
    px={300}
    sx={{
      width: 'var(--comparison-column-width)'
    }}
  >
    {children}
  </ListItem>
);

export default Cell;
